module.exports = __webpack_public_path__ + "img/5-r.b1d81354.png";